import ownerTransactionsComponent from './owner-transactions.component';

const ownerTransactionsModule = angular.module('ownerTransactions', [
])
  .component('ownerTransactions', ownerTransactionsComponent)
  .name;

export default ownerTransactionsModule;
